<template>
    <div class="main mt15">
        <div class="banner" @click="toBuy">
            <img src="../../../images/proceedingTab.jpg" alt="" ref="info">
            <div class="banner-container">
            </div>
        </div>
        <div class="tabs" ref="tabs">
            <div class="tabs-container" :class="{fixed:fixed}">
                <Tabs :value="tabName" @on-click="tabChange">
                    <TabPane label="产品特色" name="info"></TabPane>
                    <TabPane label="保障方案" name="case"></TabPane>
                    <TabPane label="常见问题" name="question"></TabPane>
                    <TabPane label="理赔流程" name="claim"></TabPane>
                </Tabs>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">产品特色</div>
            <div class="detail-main">
                <!-- <div style="color: red;">咨询电话：187 6642 6120</div> -->
                <div class="detail-main-text" ref="case">
                    诉讼财产保全责任保险，指对于保险期间内被保险人向法院提起的诉讼财产保全申请，如被保险人诉讼财产保全错误致使被申请人遭受损失的，经法院判决生效后由被保险人承担经济赔偿责任，保险人按照保险合同约定赔偿。<br />
                    诉讼财产保全责任保险是指投保人与保险公司（保险人）签订保险产品合约，保险公司以保险产品作为担保物，对诉讼当事人（被保险人）的财产保全行为进行担保，当被保险人申请错误依法应承担经济赔偿责任时，由保险人根据约定的赔偿限额负责赔偿或者先行垫付，继而实现诉讼保全担保的目的。<br />
                    该保险产品是为适应现代社会经济发展，保障民事诉讼案件中原被告双方诉讼财产权益，经保监会批准在全国范围推出的创新型保险产品，旨在解决民事诉讼中申请诉讼财产保全的担保障碍问题，具有担保成本低廉、办理程序简便、社会认可度高、赔付能力强等特点。
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">保障方案</div>
            <div class="detail-main">
                <div class="center">
                    <table class="productDetail-table">
                        <thead>
                            <tr>
                                <th>项目</th>
                                <th>内容</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hoverTr">
                                <td>保险责任</td>
                                <td>在保险期间内，被保险人向法院提出诉讼财产保全申请，对于因被保险人的诉讼保全申请错误导致被申请人遭受损失的，经法院判决由被保险人承担赔偿责任，保险人在投保范围内予以赔偿。</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>服务对象（被保险人）</td>
                                <td>向法院申请财产保全的民事诉讼当事人或厉害关系人，即财产保全申请人。</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保险标的</td>
                                <td>被保险人申请保全的财产标的</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保险期间</td>
                                <td>自被保险人向法院提出诉讼财产保全申请之日起至保全损害之债诉讼时效届满时终止。</td>
                            </tr>
                            <tr class="hoverTr">
                                <td>投保资料</td>
                                <td>财产保全申请人身份证明（营业执照或身份证复印件）、<br />
                                起诉状及证据材料、<br />
                                案件受理通知书及案件号、<br />
                                财产保全申请书
                                </td>
                            </tr>
                            <tr class="hoverTr">
                                <td>保险费率</td>
                                <td>提供上述投保资料后获取精准报价</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="mt20">
                <b>保险过程中的法律关系如下图：</b>
            </div>
            <div class="mt20" ref="question">
                <img style="width:50%;" src="../../../images/proceeding.png" alt="">
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">常见问题</div>
            <div class="detail-main">
                <div class="detail-main-text">
                    <p><b>1、企业为何选择诉讼财产保全责任保险？</b></p>
                    <p>
                        答：成本优势：相比银行贷款、企业存款、实物财产或其他机构，更为低廉。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        认可度高：保险公司资信优异，在社会何法院系统中被认可程度高，偿付能力强。
                    </p>
                    <p ref="claim"><b>2、如何投保？</b></p>
                    <p>答：提供保险申请资料后获取精准保险方案，并由服务人员协助完成投保。<br />&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    保险申请资料：财产保全申请人身份证明（营业执照或身份证复印件）、起诉状及证据材料、案件受理通知书及案件号、财产保全申请书等
                    </p>
                </div>
            </div>
        </div>
        <div class="detail">
            <div class="detail-title">理赔流程</div>
            <Steps class="mt30 step-con">
                <Step 
                    title="拨打报案电话" 
                    status="process"
                    content="请立即拨打报案电话18766426120进行报案，详细说明出险情况。被保险人应在48小时内及时报案。"
                ></Step>
                <Step 
                    title="提交索赔材料" 
                    status="process"
                    content="报案后我们会告知您所需的材料，请按照要求待治疗结束后提供资料。"
                ></Step>
                <Step 
                    title="领取赔款" 
                    status="process"
                    content="资料收到后，保险公司核定损失，确定赔偿金额，按照约定赔付方式支付赔款。"
                ></Step>
            </Steps>
        </div>
        
        <div class="detail allDet detail-main-text">
             <p>
                <b>请添加以下微信进行询价</b>
             </p>
            <img src="../../../images/code.png"  style="width: 20%;margin-top: 15px;" alt="">
        </div>
    </div>
</template>
<script>
    export default {
        data () {
            return {
                rules: {
                    code: [{ required: true, message: '请输入88码', trigger: 'blur' }]
                },
                tabName: 'info',
                fixed: false,
                renewId: this.$route.query.renewId || '' //续保，上一保单id
            }
        },
        mounted () {
            this.$nextTick(() => {
                window.addEventListener("scroll", this.handleScroll);
            })
        },
        beforeDestroy () {
            window.removeEventListener('scroll', this.handleScroll)
        },
        methods: {
            // 立即购买
            toBuy () {
                let url = '/haierProduct.html#/customized-employer-liability/fillin';
                if (this.renewId) url += `/${this.renewId}?renew=1&productCode=QYTTGZZRXPCNEW`
                else url += `?productCode=QYTTGZZRXPCNEW`
                location.href = url
            },
            // tab切换
            tabChange (val) {
                this.$refs[val].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                    block: "start"
                })
            },
            // 定位到伤残费率表位置
            toSC () {
                this.$refs['SC'].scrollIntoView({
                    behavior: "smooth",  // 平滑过渡
                })
            },
            // 监听滚动
            handleScroll () {
                //获取滚动时的高度
                let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
                if (scrollTop > this.$refs.tabs.offsetTop) {
                    this.fixed = true;
                } else {
                    this.fixed = false;
                }
            }
        }
    }
</script>
<style scoped lang="less">
    .main {
        margin-bottom: 30px;
    }

    .pb50 {
        padding-bottom: 50px;
    }

    .pt40 {
        padding-top: 40px;
    }

    .banner-container {
        position: absolute;
        font-size: 14px;
        text-align: center;
        width: 510px;
        top: 80px;
        left: 0;
        right: 0;
        color: #fff;

        .notes {
            margin-top: 10px;
        }

        &-title {
            font-size: 32px;
            color: #333;
        }

        &-case {
            font-size: 24px;
            line-height: 2;
            color: #318af0;
        }

        &-sub {
            font-size: 14px;
            color: #555;
            margin-top: 30px;

            span {
                margin-right: 5px;
            }
        }

        &-desc {
            font-size: 18px;
        }

        &-input {
            width: 300px;
            margin: 20px auto 0;
        }

        &-btn {
            margin-top: 30px;

            a {
                width: 240px;
            }
        }
    }

    .detail-title {
        font-size: 30px;
    }

    .detail-main {
        .center {
            font-size: 0;
        }

        &-title,
        &-text {
            // padding-left: 20px;
        }

        &-title {
            font-size: 18px;
        }

        &-text {
            line-height: 2;
        }
    }

    .tabs {
        display: block;
        height: 46px;

        &-container {
            padding: 10px 10px 0;
            background: #fff;
            height: 46px;
            overflow: hidden;
            position: relative;

            &-form {
                position: absolute;
                right: 10px;
                bottom: 5px;

                button {
                    display: inline-block;
                }
            }
        }

        .fixed {
            position: fixed;
            top: 100px;
            left: 0;
            right: 0;
            margin: auto;
            width: 1200px;
        }
    }

    .productDetail-table.sm {
        font-size: 13px;

        .fs16 {
            font-size: 16px;
        }

        td {
            padding: 8px;
        }
    }

    .hoverTr:hover {
        color: #fff;

        td {
            background: #77adf5;
        }

        .hoverDisabled {
            background: #fafafa;
            color: #333;
        }
    }

    .importantText {
        color: #77adf5;
    }

    .tit {
        font-size: 18px;
        margin: 10px 0;
    }
</style>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/customizedEmployerLiability/productList/proceeding.vue